import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../hooks/usePageMeta';
import { Lotus } from '../components/ui/Icons';

export default function NotFound() {
  usePageMeta({
    title: 'Page not found | Pramukh Jewellers',
    description: 'The page you were looking for is not here.',
  });

  return (
    <section className="relative flex min-h-[70vh] items-center overflow-hidden bg-royal-900">
      <div className="absolute inset-0">
        <img
          src="/assets/gallery/post-02.jpg"
          alt=""
          className="h-full w-full object-cover object-center opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-royal-900/85 via-royal-900/80 to-royal-900" />
      </div>

      <div className="shell relative py-20 text-center">
        <Lotus className="mx-auto h-8 w-auto text-gold/70" />
        <p className="mt-8 font-display text-[5rem] leading-none text-gold-grad sm:text-[7rem]">404</p>
        <h1 className="mt-4 font-display text-[2rem] leading-tight text-cream sm:text-[2.6rem]">
          This piece is not in the case
        </h1>
        <p className="mx-auto mt-5 max-w-md text-[15px] font-light leading-relaxed text-cream/80">
          The page you were looking for has moved or never existed. Let us show you what is here instead.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          <Link to="/" className="btn-line-light">
            <span className="btn-line-rule" />
            Back to home
          </Link>
          <Link
            to="/collections"
            className="text-[12px] font-medium uppercase tracking-luxe text-cream/70 transition-colors duration-500 hover:text-gold-200"
          >
            Browse collections
          </Link>
        </div>
      </div>
    </section>
  );
}
